import { Tabs, TabsContent, TabsList, TabsTrigger } from '@ps/isp-web-component-library';
import { useTrackers } from '@ps/web-shared-analytics';
import { Translation, useTrackingLabel } from '@ps/web-shared-components';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import GroupedTemplatePanels from '@swf/sports/components/GroupedTemplatePanels/GroupedTemplatePanels';

import { useSportsCompetitionEventsWidget } from '../model';

import { TXTWCL_Doubles_1, TXTWCL_Singles_1 } from './TennisGroups.messages.json';
import styles from './TennisGroups.scss';

export const TennisGroups = () => {
  const { widgetSelect } = useSportsCompetitionEventsWidget();
  const { tabClicked } = useTrackers();
  const singlesTrackingLabel = useTrackingLabel(TXTWCL_Singles_1);
  const doublesTrackingLabel = useTrackingLabel(TXTWCL_Doubles_1);

  const templateGroupsForSingles = useSelector(widgetSelect.templateGroupsForSingles);
  const templateGroupsForDoubles = useSelector(widgetSelect.templateGroupsForDoubles);
  const marketTemplateData = useSelector(widgetSelect.marketTemplateData);

  const [selectedTab, setSelectedTab] = useState(() =>
    templateGroupsForSingles.length ? 'singles' : 'doubles'
  );

  useEffect(() => {
    if (selectedTab === 'singles' && !templateGroupsForSingles.length) {
      setSelectedTab('doubles');
    }

    if (selectedTab === 'doubles' && !templateGroupsForDoubles.length) {
      setSelectedTab('singles');
    }
  }, [selectedTab, templateGroupsForDoubles.length, templateGroupsForSingles.length]);

  const handleTabClick = (trackingLabel: string | undefined) => {
    tabClicked({
      tabName: trackingLabel ?? ''
    });
  };

  return (
    <Tabs className={styles.tabsWrapper} value={selectedTab} onValueChange={setSelectedTab}>
      <TabsList>
        <TabsTrigger
          value="singles"
          disabled={!templateGroupsForSingles.length}
          onClick={() => handleTabClick(singlesTrackingLabel)}
        >
          <Translation {...TXTWCL_Singles_1} />
        </TabsTrigger>
        <TabsTrigger
          value="doubles"
          disabled={!templateGroupsForDoubles.length}
          onClick={() => handleTabClick(doublesTrackingLabel)}
        >
          <Translation {...TXTWCL_Doubles_1} />
        </TabsTrigger>
      </TabsList>
      <TabsContent value="singles">
        {templateGroupsForSingles.length ? (
          <GroupedTemplatePanels
            groupedOn="DATE"
            groups={templateGroupsForSingles}
            {...marketTemplateData}
            isFlush
          />
        ) : null}
      </TabsContent>
      <TabsContent value="doubles">
        {templateGroupsForDoubles.length ? (
          <GroupedTemplatePanels
            groupedOn="DATE"
            groups={templateGroupsForDoubles}
            {...marketTemplateData}
            isFlush
          />
        ) : null}
      </TabsContent>
    </Tabs>
  );
};
